import { PagedResultDto } from "@services/dto/pagedResultDto"
import http from "../httpService"
import { L, LNotification } from "@lib/abpUtility"
import { notifyError, notifySuccess } from "@lib/helper"

class UnitFacilityService {
  public async getAll(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/UnitFacilities/GetAll", {
      params,
    })
    return res.data.result
  }
  public async get(id: number): Promise<any> {
    if (!id) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }
    const res = await http.get("api/services/app/UnitFacilities/Get", {
      params: { id },
    })
    const { result } = res.data
    return result
  }

  public async createOrUpdate(body: any) {
    const res = await http.post(
      "api/services/app/UnitFacilities/CreateOrUpdate",
      body
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }
  public async activate(id: number, isActive) {
    const res = await http.post(
      "api/services/app/UnitFacilities/Active",
      { id },
      { params: { isActive } }
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }
  public async getList(params): Promise<any> {
    const res = await http.get("/api/services/app/UnitFacilities/GetList", {
      params,
    })
    const { result } = res.data

    return result
  }
}

export default new UnitFacilityService()
